export const ja = {
  // Navigation
  'nav.search.placeholder': 'スレッド、求人、質問を検索...',
  'nav.anonymous.mode': '[匿名モード]',
  
  // Sidebar Menu
  'menu.feed': 'フィード',
  'menu.jobs': '求人',
  'menu.study': 'スタディ',
  'menu.knowledge': 'ナレッジ',
  'menu.learning': '学習サイト',
  'menu.premium': 'プレミアム',
  'menu.news': 'ニュース',
  'menu.bugbounty': 'バグバウンティ',
  
  // Feed Tab
  'feed.title': 'ライブフィード',
  'feed.new.post': '+ 新規投稿',
  'feed.category.all': 'すべて',
  'feed.category.vulnerability': '脆弱性',
  'feed.category.study': 'スタディ',
  'feed.category.job': '求人',
  'feed.category.knowledge': 'ナレッジ',
  'feed.replies': '返信',
  'feed.likes': 'いいね',
  
  // Jobs Tab
  'jobs.title': '求人掲示板',
  'jobs.post.job': '+ 求人投稿',
  'jobs.salary': '給与',
  'jobs.location': '場所',
  'jobs.experience': '経験',
  'jobs.apply.now': '[応募する]',
  
  // Study Tab
  'study.title': 'スタディQ&A',
  'study.ask.question': '+ 質問する',
  'study.answers': '回答',
  'study.views': '閲覧',
  'study.solved': '✓ 解決済み',
  
  // Knowledge Tab
  'knowledge.title': 'ハッカーナレッジ',
  'knowledge.subtitle': 'リアルタイムハッキングQ&A - 賞金システム',
  'knowledge.ask.bounty': '+ 賞金付き質問',
  'knowledge.answered': '✓ 回答済み',
  'knowledge.pending': '⏱ 保留中',
  'knowledge.points': 'ポイント',
  
  // Learning Tab
  'learning.title': '学習サイト',
  'learning.subtitle': 'ハッキング学習のための厳選サイト集',
  'learning.difficulty': '難易度',
  'learning.users': 'ユーザー',
  
  // Premium Tab
  'premium.title': 'プレミアムアーカイブ',
  'premium.subtitle': '実践ハッキング試行錯誤アーカイブ - プレミアム会員限定',
  'premium.only': 'プレミアム限定',
  'premium.exclusive': 'プレミアム会員限定コンテンツ',
  'premium.cases': 'ケース',
  'premium.membership': 'プレミアム会員',
  'premium.description': '実践ハッキング試行錯誤アーカイブ、専門家1:1メンタリング、プレミアムスタディグループなど、すべてのプレミアムコンテンツへの無制限アクセス',
  'premium.price': '¥9,900 / 月',
  'premium.upgrade.now': '[アップグレード]',
  'premium.modal.title': 'プレミアム会員が必要です',
  'premium.modal.description': 'このコンテンツはプレミアム会員限定です。実践ハッキング試行錯誤アーカイブとすべてのプレミアム機能をご利用ください。',
  'premium.modal.upgrade': '[プレミアムにアップグレード]',
  'premium.modal.close': '[閉じる]',
  
  // Sidebar Stats
  'stats.title': '// ライブ統計',
  'stats.online.hackers': 'オンラインハッカー',
  'stats.today.posts': '今日の投稿',
  'stats.active.threads': 'アクティブスレッド',
  'stats.trending.tags': '// トレンドタグ',
  'stats.top.hackers': '// トップハッカー',
  
  // Time
  'time.minutes.ago': '分前',
  'time.hour.ago': '時間前',
  'time.hours.ago': '時間前',
  'time.realtime': 'リアルタイム',

  // Search
  'search.input.placeholder': '投稿、求人、質問を検索...',
  'search.tab.all': 'すべて',
  'search.tab.feed': 'フィード',
  'search.tab.jobs': '求人',
  'search.tab.study': 'スタディ',
  'search.tab.knowledge': 'ナレッジ',
  'search.trending': 'トレンドタグ',
  'search.popular': '人気投稿',
  'search.results.count': '件の検索結果',
  'search.sort.relevance': '関連度',
  'search.sort.latest': '最新順',
  'search.sort.popular': '人気順',
  'search.no.results': '検索結果がありません',
  'search.no.results.hint': '別のキーワードで検索してください',
  'search.just.now': 'たった今',
  'search.type.feed': 'フィード',
  'search.type.job': '求人',
  'search.type.study': 'スタディ',
  'search.type.knowledge': 'ナレッジ',

  // Notifications
  'notifications.title': '通知',
  'notifications.all': 'すべて',
  'notifications.unread': '未読',
  'notifications.mark.all.read': 'すべて既読にする',
  'notifications.no.unread': '未読の通知はありません',
  'notifications.no.notifications': '通知はありません',
  'notifications.new': '新規',
  'notifications.delete': '削除',

  // News Tab
  'news.title': 'ハッキングニュース',
  'news.subtitle': 'Hacker News & コミュニティセキュリティニュース',
  'news.share.news': '+ ニュース共有',
  'news.category.all': '全て',
  'news.category.vulnerability': '脆弱性',
  'news.category.breach': 'データ漏洩',
  'news.category.malware': 'マルウェア',
  'news.category.bounty': 'バグバウンティ',
  'news.community': 'コミュニティ',
  'bugbounty.title': 'バグバウンティゾーン',
  'bugbounty.subtitle': 'グローバルバグバウンティプログラムと最新の脆弱性レポートを確認',
  'bugbounty.platforms.title': 'バグバウンティプラットフォーム',
  'bugbounty.writeups.title': '最近公開されたWriteup',
  'bugbounty.tips.title': 'バグバウンティ入門ガイド',
  'bugbounty.tips.start.title': '小さく始める',
  'bugbounty.tips.start.description': '最初は難易度の低いプログラムから始めましょう。XSS、IDOR、CSRFなどの基本的な脆弱性を見つける練習をし、徐々に複雑な脆弱性に拡張していきましょう。',
  'bugbounty.tips.tools.title': '必須ツールを習得',
  'bugbounty.tips.tools.description': 'Burp Suite、OWASP ZAP、Nuclei、ffuf、SQLMapなどのツールを習得しましょう。自動化ツールと手動テストを併用すると、より多くの脆弱性を発見できます。',
  'bugbounty.tips.report.title': '明確なレポート作成',
  'bugbounty.tips.report.description': '脆弱性を発見したら、再現手順、影響度、PoCを明確に記述しましょう。良いレポートは迅速な検証と高い報酬につながります。',
  'bugbounty.tips.community.title': 'コミュニティ参加',
  'bugbounty.tips.community.description': 'Twitter、Discord、Redditのバグバウンティコミュニティに参加しましょう。他のハンターのwriteupを読み、最新のトレンドと技術を学べます。',
};

export default ja;
